import type { ResponseError, SchedulePage } from '@rtkwlf/rendall';
import type {
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { useOrganizationContext } from '@packages/legacy/organization-context';

import { useRendallApi } from '../use-rendall-api';

export const getScanSchedulesQueryKey = (
  orgId: string,
  scannerId: string,
): QueryKey => [orgId, 'rendall', 'get-scanner-scan-schedules', scannerId];

export const useGetScannerScanSchedules = <T = SchedulePage>(
  scannerId: string,
  options?: Omit<
    UseQueryOptions<SchedulePage, ResponseError, T>,
    'queryKey' | 'queryFn'
  >,
): UseQueryResult<T> => {
  const api = useRendallApi();
  const { selectedOrganization } = useOrganizationContext();
  return useQuery({
    queryFn: () =>
      api.getScannerScanSchedules({
        organizationId: selectedOrganization.id,
        scannerId,
      }),
    queryKey: getScanSchedulesQueryKey(selectedOrganization.id, scannerId),
    ...options,
  });
};
